import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import { UserDataFormComponent } from '../user-data-form/user-data-form.component';
import { ApiAmenaService } from '../../services/api-amena.service';
import { UserDataService } from '../../services/user-data.service';
import { GeneralService } from '../../services/general.service';
import { UserDataModel } from '../../interface/user-data-model';
import { UserDataListener } from '../../interface/user-data-listener';

@Component({
    selector: 'app-user-data',
    templateUrl: './user-data.component.html',
    styleUrls: ['./user-data.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class UserDataComponent implements OnInit, AfterViewInit, UserDataListener {
    @Input() thirdFormGroup: FormGroup;
    @ViewChild('userDataForm') userDataForm: UserDataFormComponent;

    userData: UserDataModel;
    public migrationData: any;

    constructor(
        private formBuilder: FormBuilder,
        private amenaService: ApiAmenaService,
        private userDataService: UserDataService,
        private generalService: GeneralService,
        private stepper: MatStepper
    ) { }

    ngOnInit(): void {
        this.thirdFormGroup = this.formBuilder.group({});

        this.amenaService.getMigrationData()
            .subscribe(data => {
                this.migrationData = data;
            });
    }

    ngAfterViewInit(): void {
        this.generalService.getEmptyFormUserData()
            .subscribe(data => {
                if (data != null) {
                    this.userData = data;
                    this.userDataForm.fillData(this.userData);
                }
            });
    }

    previo() {
        this.stepper.previous();
    }

    validar(event) {
        // this.thirdFormGroup.markAsDirty();
        // this.thirdFormGroup.markAllAsTouched();
        // this.thirdFormGroup.updateValueAndValidity();
        // console.log(this.thirdFormGroup.get('company').valid);
        // console.log(this.thirdFormGroup.get('bank_account').value, this.thirdFormGroup.get('bank_account').valid);
        // if (this.thirdFormGroup.valid) {
        //     this.stepper.next();
        // }
        this.userDataForm.validateForm();
    }

    // UserDataListener
    onSuccessfulValidation(userData: UserDataModel) {
        this.stepper.selected.completed = true;
        this.userDataService.setUserValidation(true);
        this.stepper.next();
    }
}
